import { h } from 'preact';
import { useUser } from '../../hooks/user';

/**
 * SourceCode input.
 * Generally only used for 'caging' forms.
 * Allows user to enter source code value.
 * Codes entered here will take precedence over any url params or default values.
 */
const SourceCode = () => {
	const { dispatch, user } = useUser();
	const { sourceCodeName } = user;

	return (
		<div className="ea-source-code">
			<label className="ea-label" htmlFor="ea-source-code">Source Code</label>
			<input
				className="ea-input"
				type="text"
				id="ea-source-code"
				name="ea-source-code"
				placeholder="Enter source code"
				value={sourceCodeName}
				onChange={(e) => {
					dispatch({
						type: 'UPDATE_USER',
						payload: {
							sourceCodeName: e.currentTarget.value,
						},
					});
				}}
			/>
		</div>
	);
};

export default SourceCode;
